import { authRequiredForSecondaryOpsExp } from './constants';
import { getErrorMessage } from './getErrorMessage';
export const isAuthRequiredForSecondaryOps = (error) => {
    return authRequiredForSecondaryOpsExp.test(getErrorMessage(error));
};
